<template>
  <div class="for-thank-you">
    <top-header yellow />
    <div class="for-thank-you-content">
      <div class="for-thank-you-box">
        <div class="for-thank-you-box-title">Thank you for signing up!</div>
        <div class="for-thank-you-box-text">Please take the time to  give us a review if you receive a review request!</div>
      </div>
    </div>
    <app-footer />
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader'
import AppFooter from '@/components/AppFooter'
export default {
  components: {
    TopHeader,
    AppFooter
  },
  mounted () {
  }
}
</script>

<style lang="scss">
  @import '~@/styles/media';

  .for-thank-you-content {
    width: 100%;
    background-image: url('~@/assets/images/thank-you-bg.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    height: calc(100vh - 443px);
    display: flex;
    align-items: center;
    justify-content: center;

    @media #{$mobile} {
      height: calc(100vh - 404px);
    }

    .for-thank-you-box {
      padding: 40px;
      background: #fff;
      border-radius: 12px;
      max-width: 430px;

      @media #{$mobile} {
        max-width: 280px;
      }

      &-title {
        color: #101010;
        font-size: 38px;
        font-weight: 400;
        line-height: 42px;
        text-align: center;
        margin-bottom: 25px;

        @media #{$mobile} {
          font-size: 28px;
        }
      }

      &-text {
        font-size: 16px;
        font-weight: 400;
        line-height: 26px;
        text-align: center;
      }
    }
  }
</style>
